import { __makeTemplateObject } from "tslib";
import { css, spacing } from '../../../../foundation';
// TODO: use token in theme.transitions.easing
var hoverTransitionEasing = "cubic-bezier(0.25, 0.8, 0.25, 1)";
export var hoverTransition = function (_a) {
    var theme = _a.theme;
    return theme.transitions.create(['opacity'], {
        easing: hoverTransitionEasing,
        duration: theme.transitions.duration.standard,
    });
};
export var CardHoverActionsStyle = function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    right: 0;\n    top: 0;\n    padding: ", ";\n    transition: ", ";\n    ", "\n    z-index: 1;\n  "], ["\n    position: absolute;\n    right: 0;\n    top: 0;\n    padding: ", ";\n    transition: ", ";\n    ",
        "\n    z-index: 1;\n  "])), spacing(4), hoverTransition, '' /* make sure `CardHoverActions` would not be covered by `CardActionArea`  */);
};
var templateObject_1;
